const SERVICE_NAME = 'WEBSOCKET_SERVICE';

export const WEBSOCKET_SERVICE_OPEN = SERVICE_NAME + '_OPEN';
export const WEBSOCKET_SERVICE_ON_OPEN = SERVICE_NAME + '_ON_OPEN';
export const WEBSOCKET_SERVICE_ON_CLOSE = SERVICE_NAME + '_ON_CLOSE';
export const WEBSOCKET_SERVICE_ON_MESSAGE = SERVICE_NAME + '_ON_MESSAGE';
export const WEBSOCKET_SERVICE_ON_ERROR = SERVICE_NAME + '_ON_ERROR';
